import { useAuth0 } from '@auth0/auth0-react'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import UserItem from './UserItem'
import {
  useGetSingleProjectByUserAdmin,
  useUpdateSingleProjectByUserAdmin,
} from 'lib/react-query/queriesProject'

import Pagination from 'components/ui/Pagination/Pagination'

const LIMIT = 5

const ListUsers = () => {
  const queryClient = useQueryClient()
  const { idProject } = useParams()
  const { user } = useAuth0()
  const { mutateAsync } = useUpdateSingleProjectByUserAdmin(user.sub, idProject)

  const { data: users } = queryClient.getQueryData(['users-auth0'])
  const { data: project } = useGetSingleProjectByUserAdmin(
    user.sub,
    idProject,
    false
  )

  const handleDeleteUser = (userId, rol) => {
    const { data } = project
    if (rol === 'Administrador') {
      const currentAdministradores = data.user.filter(item => item !== userId)
      mutateAsync({ body: { user: currentAdministradores } })
    } else if (rol === 'Usuario') {
      const currentUsers = data.users.filter(item => item !== userId)
      mutateAsync({ body: { users: currentUsers } })
    }
  }

  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get('page')) || 1
  const search = searchParams.get('search')?.toLowerCase() || ''

  const allUsers = [
    ...(project?.data?.user || []).map(id => ({ id, rol: 'Administrador' })),
    ...(project?.data?.users || []).map(id => ({ id, rol: 'Usuario' })),
  ]

  const filteredUsers = allUsers.filter(({ id }) => {
    const userAuth0 = users.find(u => u.user_id === id)
    const email = userAuth0?.email?.toLowerCase() || ''
    const name = userAuth0?.name?.toLowerCase() || ''
    return email.includes(search) || name.includes(search)
  })

  const totalPages = Math.ceil(filteredUsers.length / LIMIT)
  const paginatedUsers = filteredUsers.slice((page - 1) * LIMIT, page * LIMIT)

  return (
    <div className="user-list-container">
      <h3 className="user-title-list">Usuarios</h3>
      {paginatedUsers.length === 0 ? (
        <p className="no-users-message">
          No se han encontrado usuarios con ese término.
        </p>
      ) : (
        paginatedUsers.map(({ id, rol }) => {
          const userAuth0 = users.find(u => u.user_id === id)
          return (
            <UserItem
              key={id}
              user={userAuth0 || { email: id }}
              rol={rol}
              handleDeleteUser={() => handleDeleteUser(id, rol)}
            />
          )
        })
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          handlePage={newPage => {
            const params = new URLSearchParams(searchParams.toString())
            params.set('page', newPage)
            setSearchParams(params)
          }}
        />
      )}
    </div>
  )
}

export default ListUsers
